module.exports = __webpack_public_path__ + "assets/personalIdVerification.673ebdbe.svg";